import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { ChecklistAnsweredDetailComponent } from './report/checklist-answered/checklist-answered-detail/checklist-answered-detail.component';
import { QuestionUnconformityResponseComponent } from './report/question-uncoformity-response/question-uncoformity-response.component';
import { ChecklistAnsweredComponent } from './report/checklist-answered/checklist-answered.component';
import { DynamicListItemComponent } from './dynamic-list-item/dynamic-list-item.component';
import { ReviewDetailComponent } from './review/review-detail/review-detail.component';
import { InspectionPlanComponent } from './inspection-plan/inspection-plan.component';
import { OrderDetailComponent } from './order/order-detail/order-detail.component';
import { ChecklistFormComponent } from './checklist-form/checklist-form.component';
import { InstituteTypeComponent } from './institute-type/institute-type.component';
import { UnconformityComponent } from './unconformity/unconformity.component';
import { DynamicListComponent } from './dynamic-list/dynamic-list.component';
import { DepartamentComponent } from './departament/departament.component';
import { ActionPlanComponent } from './action-plan/action-plan.component';
import { MeasureTableComponent } from './measure-table/measure-table.component';
import { MeasureTableFormComponent } from './measure-table/measure-table-form/measure-table-form.component';
import { ProductComponent } from './product/product.component';
import { ProductFormComponent } from './product/product-form/product-form.component';
import { SchedulingComponent } from './scheduling/scheduling.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InstituteComponent } from './institute/institute.component';
import { UserTypeComponent } from './user-type/user-type.component';
import { RedirectComponent } from './redirect/redirect.component';
import { ConfigComponent } from './config/config.component';
import { ReviewComponent } from './review/review.component';
import { OrderComponent } from './order/order.component';
import { EmailComponent } from './email/email.component';
import { LoginComponent } from './login/login.component';
import { ListComponent } from './list/list.component';
import { UserComponent } from './user/user.component';
import { AuthGuard } from './auth/auth.guard';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'redirect', component: RedirectComponent },
    {
        path: '',
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard],
        children: [
            { path: '', component: DashboardComponent },
            { path: 'config', component: ConfigComponent },

            { path: 'user', component: UserComponent },
            { path: 'user-type', component: UserTypeComponent },

            { path: 'list', component: ListComponent },
            { path: 'dynamic-list', component: DynamicListComponent },
            { path: 'inspection-plan', component: InspectionPlanComponent },
            { path: 'dynamic-list-item', component: DynamicListItemComponent },

            { path: 'email', component: EmailComponent },
            { path: 'checklist', component: ChecklistComponent },
            { path: 'institute', component: InstituteComponent },
            { path: 'departament', component: DepartamentComponent },
            { path: 'unconformity', component: UnconformityComponent },
            { path: 'institute-type', component: InstituteTypeComponent },
            // { path: 'checklist-form', component: ChecklistFormComponent },
            {
                path: 'checklist-form',
                children: [
                    { path: '', component: ChecklistFormComponent },
                    { path: ':id', component: ChecklistFormComponent }
                ]
            },
            {
                path: 'checklist-answered',
                children: [
                    { path: '', component: ChecklistAnsweredComponent },
                    { path: ':id', component: ChecklistAnsweredDetailComponent }
                ]
            },
            {
                path: 'question-unconformity-response',
                children: [
                    { path: '', component: QuestionUnconformityResponseComponent },
                ]
            },
            {
                path: 'order',
                children: [
                    { path: '', component: OrderComponent },
                    { path: 'order-detail', component: OrderDetailComponent }
                ]
            },
            {
                path: 'review',
                children: [
                    { path: '', component: ReviewComponent },
                    { path: 'review-detail', component: ReviewDetailComponent }
                ]
            },
            { path: 'action-plan', component: ActionPlanComponent },
            { path: 'scheduling', component: SchedulingComponent},
            {
                path: 'measure-table',
                children: [
                    { path: '', component: MeasureTableComponent },
                    { path: 'new', component: MeasureTableFormComponent },
                    { path: ':id', component: MeasureTableFormComponent }
                ]
            },
            {
                path: 'product',
                children: [
                    { path: '', component: ProductComponent },
                    { path: 'new', component: ProductFormComponent },
                    { path: ':id', component: ProductFormComponent }
                ]
            },
        ]
    }
];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/app.routes.ts